
import Sindiswa from "../assets/Sindiswa.jpeg";
import Antonie from "../assets/Antonie.jpeg";
import Latie from "../assets/Molatelo.jpeg";
import Clement from "../assets/ClementMidrand.jpeg";
import Lungile from "../assets/FamLungile.jpeg";
import Fana from "../assets/Famfana.jpeg";
import Owami from "../assets/FamOwami.jpeg";
import Njabulo from "../assets/FamNjabulo.jpeg";
import MamFundisi from "../assets/ChurchMamFundisi.jpeg";







export const testimonialsData = [
  {
    image: Clement,
    review:
      "I had issues with consistency, Starting this was the best decision I took",
    name: 'CLEMENT JELE',
    status : 'ENTREPRENEUR'
  },
  {
    image: Sindiswa,
    review: 'I love going to bettlehem so I am alwayshome hence I had to join in order to make certain I stay in shape and still go home',
    name: 'SINDISWA RADEBE',
    status: 'ANALYST'
  },
  {
    image : Antonie,
    review:' I am working on a calender web application, seldom my trainer would come to me instead so that I can train at the comfort of my own home',
    name: 'ANTONIE VAN DER LINGEN',
    status: "BACKEND-PROGRAMMER"
  },
  {
    image : Latie,
    review:'The fit was the one hack I never knew I needed until I got it',
    name: 'MOLATELO KUTUMELA',
    status: "CA"
  },
  {
    image : Lungile,
    review:'Heavenly Sent',
    name: 'Lungile Ndlovu',
    status: "Programmer"
  },
  {
    image : Fana,
    review:'I have been a lazy one',
    name: 'Fana Jele',
    status: "Rugby Player"
  },
  {
    image : Owami,
    review:'Great value for money',
    name: 'Owami Pheme',
    status: "Auditor"
  },
  {
    image : Njabulo,
    review:'The service is well appreciated, It may have been the greatest decision I have ever taken in 2023',
    name: 'Njabulo',
    status: "Lawyer"
  },
  {
    image : MamFundisi,
    review:'Gym is my life, Under the great stress of electricity outage It has been my go-to for peace of mind. Great choice and value for my money, plus I bought a new car',
    name: 'Nana Bulelwa Ngxoxo',
    status: "CA(Risk)"
  }
];
